import styled from 'styled-components';
import {
    heading1Theme,
    heading2Theme,
    heading3Theme,
    heading4Theme,
    heading5Theme,
    heading6Theme,
    body1Theme,
    body2Theme,
    subtitle1Theme,
    subtitle2Theme,
    subtitle3Theme,
    captionTheme,
    overlineTheme,
    DarkClassName
} from '../theme/default-theme';
import { Emphasis, IEmphasisProps } from '@estee/elc-base-theme';

export interface ITextProps {
    emphasis?: IEmphasisProps;
    darkTheme?: boolean;
    htmlFor?: string;
}

const classes = (cls: string, props: ITextProps) =>
    `${cls} ${props.emphasis ? props.emphasis.className : Emphasis.high.className} ${
        props.darkTheme ? DarkClassName : ''
    }`.trim();

export const Heading1 = styled.h1.attrs<ITextProps>(props => ({
    className: classes('elc-heading--1', props)
}))<ITextProps>`
    ${heading1Theme};
`;

export const Heading2 = styled.h2.attrs<ITextProps>(props => ({
    className: classes('elc-heading--2', props)
}))<ITextProps>`
    ${heading2Theme};
`;

export const Heading3 = styled.h3.attrs<ITextProps>(props => ({
    className: classes('elc-heading--3', props)
}))<ITextProps>`
    ${heading3Theme};
`;

export const Heading4 = styled.h4.attrs<ITextProps>(props => ({
    className: classes('elc-heading--4', props)
}))<ITextProps>`
    ${heading4Theme};
`;

export const Heading5 = styled.h5.attrs<ITextProps>(props => ({
    className: classes('elc-heading--5', props)
}))<ITextProps>`
    ${heading5Theme};
`;

export const Heading6 = styled.h6.attrs<ITextProps>(props => ({
    className: classes('elc-heading--6', props)
}))<ITextProps>`
    ${heading6Theme};
`;

export const Body1 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-body--1', props)
}))<ITextProps>`
    ${body1Theme};
`;

export const Body2 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-body--2', props)
}))<ITextProps>`
    ${body2Theme};
`;

export const Subtitle1 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--1', props)
}))<ITextProps>`
    ${subtitle1Theme};
`;

export const Subtitle2 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--2', props)
}))<ITextProps>`
    ${subtitle2Theme};
`;

export const Subtitle3 = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-subtitle--3', props)
}))<ITextProps>`
    ${subtitle3Theme};
`;

export const Caption = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-caption', props)
}))<ITextProps>`
    ${captionTheme};
`;

export const Overline = styled.p.attrs<ITextProps>(props => ({
    className: classes('elc-overline', props)
}))<ITextProps>`
    ${overlineTheme};
`;
